// extracted by mini-css-extract-plugin
module.exports = {"load-more-button":"Ag6za"};